<div class="task-report-wrapper">
	<header class="task-report-header">
		<h1 class="task-report-title">
			{{ 'task-report_header-title' | translate }}
		</h1>
		<ngx-overview-navigation></ngx-overview-navigation>
	</header>

	@if (isLoading$ | async) {
		<div class="task-report-loading">
			<loading></loading>
		</div>
	}

	@if (error$ | async; as error) {
		<div class="task-report-error">
			{{ error }}
		</div>
	}

	@if (reportData$ | async; as reportData) {
		@if (reportData.rows.length === 0) {
			<div class="task-report-empty">
				{{ 'task-report_no-data' | translate }}
			</div>
		} @else {
			<div class="task-report-scroll">
				<table class="task-report-table">
					<thead>
						<tr>
							<th class="task-report-col-learner">{{ 'task-report_learner-name' | translate }}</th>
							@for (taskTitle of reportData.taskTitles; track $index) {
								<th class="task-report-col-task">{{ taskTitle }}</th>
							}
							<th class="task-report-col-total">{{ 'task-report_total-completed' | translate }}</th>
						</tr>
					</thead>
					<tbody>
						@for (row of reportData.rows; track row.userId) {
							<tr [attr.aria-label]="getRowAriaLabel(row)">
								<td class="task-report-col-learner">{{ row.learnerName }}</td>
								@for (isCompleted of row.taskCompletions; track $index) {
									<td class="task-report-col-task">
										@if (isCompleted) {
											<i class="task-report-checkmark ficon-app-checkmark" attr.aria-label="{{ 'common_complete' | translate }}"></i>
										} @else {
											<i class="task-report-cross ficon-app-x" attr.aria-label="{{ 'common_incomplete' | translate }}"></i>
										}
									</td>
								}
								<td class="task-report-col-total">{{ row.totalCompleted }}/{{ reportData.taskNames.length }}</td>
							</tr>
						}
					</tbody>
				</table>
			</div>
		}
	}
</div>

